import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { compose } from 'recompose';

import { Icon, Button } from 'shared/components';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import theme from './ModalNotificationAboutStartConsultation.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  bodyValues: PropTypes.shape().isRequired,
  body: PropTypes.string.isRequired,
};

const okMessage = { id: 'const.button.ok', defaultMessage: '** OK' };
const headerMessage = { id: 'app.notificationAboutStartConsultation.header', defaultMessage: '** Appointment about to start' };

const NotificationAboutStartConsultation = ({
  intl,
  onOk,
  onCancel,
  body = ' ',
  bodyValues,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div className={ theme.iconContainer }>
        <Icon
          className={ theme.icon }
          name="exclamation-outline"
        />
      </div>
      <span className={ theme.message }>
        <FormattedMessage { ...headerMessage } />
      </span>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.main }>
      <FormattedMessage id={ body } values={ bodyValues } />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="modal-about-start-consultation-ok-button"
        label={ intl.formatMessage(okMessage) }
        onClick={ onOk }
        iconPositionLeft
      />
    </div>
  </div>
);

NotificationAboutStartConsultation.propTypes = propTypes;

export default compose(
  withEscHandler,
  injectIntl,
)(NotificationAboutStartConsultation);
